import React, { useState, useMemo } from 'react';
import { ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';


const PointCoverage = ({ points, toggleVisibility, zoomToFeature, handlePointColorChange }) => {
    // We'll track expanded state per feature group (e.g., "Trees", "Hydrants")
    const [expandedGroups, setExpandedGroups] = useState({});


    // console.log("points", points);
    // Group points by name (feature_name)
    const groupedPoints = useMemo(() => {
        return points.reduce((acc, p) => {
            if (!acc[p.name]) acc[p.name] = [];
            acc[p.name].push(p);
            return acc;
        }, {});
    }, [points]);

    const allVisible = points.length > 0 && points.every(p => p.visible);

    // Mock toggle for "All" visibility since Points usually follow the same pattern
    const toggleAll = () => {
        const target = !allVisible;
        points.forEach(p => {
            if (p.visible !== target) toggleVisibility(p.id, 'point');
        });
    };

    return (
        <div className="coverage-section point-coverage-section">
            {/* Header matches LineCoverage style */}
            <div className="coverage-header">
                <div className="coverage-header-left">
                    <i className="fas fa-map-marker-alt" /> 
                    <span>Point Coverage</span>
                </div>

                <div className="total-badge">
                    <i className="fas fa-dot-circle" />
                    <span>{points.length} Points</span>
                </div>

                <div className="coverage-header-right">
                    <button className={`section-eye-toggle ${allVisible ? 'active' : ''}`} onClick={toggleAll}>
                        <i className={`fas ${allVisible ? 'fa-eye' : 'fa-eye-slash'}`} />
                    </button>
                </div>
            </div>

            <table className="coverage-table">
                <tbody>
                    {Object.keys(groupedPoints).map(groupName => {
                        const group = groupedPoints[groupName];
                        const groupVisible = group.every(p => p.visible);
                        const isExpanded = expandedGroups[groupName];

                        return (
                            <React.Fragment key={groupName}>
                                {/* Group Row */}
                                <tr className="group-header-row">
                                    <td className="feature-name-cell">
                                        <div className="feature-left">
                                            <button 
                                                className={`collapse-btn ${isExpanded ? 'active' : ''}`} 
                                                onClick={() => setExpandedGroups(p => ({...p, [groupName]: !p[groupName]}))}
                                            >
                                                {/* <i className={`fas fa-chevron-${isExpanded ? 'down' : 'right'}`} /> */}

{isExpanded ? <ChevronDown size={15} /> :  <ChevronRight size={15} />}  

                                            </button>
                                            
                                            {/* Color Picker Box */}
                                            <div className="feature-color-box" style={{ 
                                                background: group[0].color, 
                                                height: '12px', 
                                                width: '12px', 
                                                borderRadius: '50%', 
                                                position: 'relative',
                                                border: '2px solid white',
                                                boxShadow: '0 0 2px rgba(0,0,0,0.3)'
                                            }}>
                                                <input 
                                                    type="color" 
                                                    value={group[0].color} 
                                                    onChange={(e) => handlePointColorChange(groupName, e.target.value)} 
                                                    style={{ opacity: 0, position: 'absolute', inset: 0, cursor: 'pointer' }} 
                                                />
                                            </div>
                                            
                                            <div className="feature-name">
                                                {groupName} <span className="count-badge">({group.length})</span>
                                            </div>
                                        </div>
                                    </td>
                                    
                                    <td className="feature-value-cell">
                                        <div className="feature-right">
                                            <button className="eye-toggle-small" onClick={() => zoomToFeature(group.map(p => p.coords))}>
                                                <i className="fas fa-crosshairs" />
                                            </button>
                                            
                                            <button 
                                                className={`eye-toggle-small ${groupVisible ? 'active' : ''}`} 
                                                onClick={() => group.forEach(p => p.visible !== !groupVisible && toggleVisibility(p.id, 'point'))}
                                            >
                                                <i className={`fas ${groupVisible ? 'fa-eye' : 'fa-eye-slash'}`} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>

                                {/* Individual Item Rows */}
                                {isExpanded && group.map((p, idx) => (
                                    <tr key={p.id} className="sub-feature-row">
                                        <td className="feature-name-cell" style={{ paddingLeft: '40px' }}>
                                            <div className="feature-name" style={{ fontSize: '0.8rem', color: '#666' }}>
                                                <i className="fas fa-level-up-alt fa-rotate-90" style={{ marginRight: '8px', opacity: 0.5 }} />
                                                Point {idx + 1}
                                            </div>
                                        </td>
                                        <td className="feature-value-cell">
                                            <div className="feature-right">
                                                <button className="eye-toggle-small" onClick={() => zoomToFeature(p.coords, p.id)}>
                                                    <i className="fas fa-map-marker-alt" />
                                                </button>
                                                <button 
                                                    className={`eye-toggle-small ${p.visible ? 'active' : ''}`} 
                                                    onClick={() => toggleVisibility(p.id, 'point')}
                                                >
                                                    <i className={`fas ${p.visible ? 'fa-eye' : 'fa-eye-slash'}`} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>

            {/* Total Footer */}
            <div className="total-area-row">
                <div className="total-area-content">
                    <div className="total-area-label"><i className="fas fa-layer-group" /> Total Features</div>
                    <div className="total-area-value">
                        <span className="total-value">{points.length}</span>
                        <span className="total-unit">Points</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PointCoverage;